import { useTheme } from '@mui/material';
import EntityCard, { EntityCardStat } from '../dashboard/entityCard';

type Props = { agentInstance: any; openAgentInstance: (agentInstance: any) => void };

const AgentInstanceIcon = ({ agentInstance, openAgentInstance }: Props) => {
  const theme = useTheme();

  const stats: EntityCardStat[] = [];

  if (agentInstance?.usageStats) {
    const s = agentInstance.usageStats;
    if (s.dataSources !== undefined) stats.push({ label: 'sources', value: s.dataSources });
    if (s.subscribers !== undefined) stats.push({ label: 'subs', value: s.subscribers });
    if (s.subscriptions !== undefined) stats.push({ label: 'events', value: s.subscriptions });
    if (s.dataSourceItemStats?.total !== undefined) stats.push({ label: 'items', value: s.dataSourceItemStats.total });
    if (s.dataSourceItemStats?.processed !== undefined) stats.push({ label: 'done', value: s.dataSourceItemStats.processed });
    if (s.dataSourceItemStats?.failed !== undefined && s.dataSourceItemStats.failed > 0) stats.push({ label: 'failed', value: s.dataSourceItemStats.failed });
  }

  if (agentInstance?.eventSubscriptions?.length > 0) {
    if (stats.length === 0) stats.push({ label: 'events', value: agentInstance.eventSubscriptions.length });
  }

  if (agentInstance?.sourceEntities?.length > 0) {
    if (!stats.find(s => s.label === 'sources')) stats.push({ label: 'sources', value: agentInstance.sourceEntities.length });
  }

  return (
    <EntityCard
      name={agentInstance.name}
      type={agentInstance?.agentDef?.name || 'AI Agent'}
      icon={agentInstance?.agentDef?.instanceIcon || 'robot'}
      color={theme.palette.secondary.main}
      onClick={() => openAgentInstance(agentInstance)}
      statusLabel={agentInstance.active !== false ? 'active' : 'inactive'}
      description={agentInstance.description}
      stats={stats.length > 0 ? stats.slice(0, 4) : undefined}
      createdDate={agentInstance.createdDate}
      lastUpdatedDate={agentInstance.lastUpdatedDate}
    />
  );
};

export default AgentInstanceIcon;
